const methods = {
    // Comprobamos si la fila está seleccionada o no para ponerle
    // el color de fondo en verde
    rowClass(row) {
        return row.selected ? 'table-success' : '';
    }
};

export default methods;
